import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {};
const propTypes = {
  children: PropTypes.element.isRequired
};

const SimpleContainer = ({ children }) => (
  <div className={cx('simpleContainer')}>{children}</div>
);

SimpleContainer.defaultProps = defaultProps;
SimpleContainer.propTypes = propTypes;
export default SimpleContainer;



// WEBPACK FOOTER //
// ./src/components/ui/Containers/SimpleContainer.jsx